<template>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M9 0.75C9.41421 0.75 9.75 1.08579 9.75 1.5V2.37803C10.6239 2.68691 11.25 3.52034 11.25 4.5C11.25 5.47966 10.6239 6.31309 9.75 6.62197L9.75 10.5C9.75 10.9142 9.41421 11.25 9 11.25C8.58579 11.25 8.25 10.9142 8.25 10.5L8.25 6.62197C7.37611 6.31309 6.75 5.47966 6.75 4.5C6.75 3.52034 7.37611 2.68691 8.25 2.37803L8.25 1.5C8.25 1.08579 8.58579 0.75 9 0.75ZM9 5.25C9.41421 5.25 9.75 4.91421 9.75 4.5C9.75 4.08579 9.41421 3.75 9 3.75C8.58579 3.75 8.25 4.08579 8.25 4.5C8.25 4.91421 8.58579 5.25 9 5.25Z"
    fill="currentColor"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M3.75 1.5C3.75 1.08579 3.41421 0.75 3 0.75C2.58579 0.75 2.25 1.08579 2.25 1.5L2.25 5.37803C1.37611 5.68691 0.75 6.52034 0.75 7.5C0.75 8.47966 1.37611 9.31309 2.25 9.62197L2.25 10.5C2.25 10.9142 2.58579 11.25 3 11.25C3.41421 11.25 3.75 10.9142 3.75 10.5V9.62197C4.62389 9.31309 5.25 8.47966 5.25 7.5C5.25 6.52034 4.62389 5.68691 3.75 5.37803L3.75 1.5ZM3 8.25C3.41421 8.25 3.75 7.91421 3.75 7.5C3.75 7.08579 3.41421 6.75 3 6.75C2.58579 6.75 2.25 7.08579 2.25 7.5C2.25 7.91421 2.58579 8.25 3 8.25Z"
    fill="currentColor"
  />
</template>
